import React, { useState, useEffect } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import breadcrumbImage from "../../../assets/images/course/cousre.jpg";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import DOMPurify from "dompurify";

const SectionalTest = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedTest, setSelectedTest] = useState(null);
  const [paperList, setPaperList] = useState([]);
  const [bgImage, setBgImage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    modelPaperList();
        bannerimg()
  }, []);

  // API call to fetch test list
  const modelPaperList = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/model-paper-list`
      );
      if (res.data.status === "1") {
        // Filter only test_series type
        const testSeriesOnly = res.data.data.filter(
          (test) => test.type === "sectional_test"
        );
        setPaperList(testSeriesOnly || []);
      } else {
        setPaperList([]);
      }
    } catch (error) {
      console.error("Error fetching paper list:", error);
      setPaperList([]);
    }
  };
 const bannerimg = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/home-seeting-list`
      );

      const baseUrl = res.data.imagePath;
      const courseImage = res.data.home_setting[0]?.course_image;

      // Full image URL
      const fullUrl = baseUrl + courseImage;

      setBgImage(fullUrl);
    } catch (error) {
      console.error("Error fetching banner:", error);
    }
  };
  // Instructions formatting
  const renderInstructions = (desc) => {
    if (!desc) return null;
    return desc.split("\n").map((line, idx) => <li key={idx}>{line}</li>);
  };

const handleAction = (test) => {
  // Redirect to instructions page with test data
  navigate("/model-paper-instructions")
   localStorage.setItem("test_id", test.id);
   
};
  const handleStartTest = (test) => {
    localStorage.setItem("test_id", test.id);
    navigate("/demo-exam");
  };

  return (
    <section className="course Test">
      <div className="page_header"></div>
      <div className="rs-breadcrumbs breadcrumbs-overlay">
        <div className="breadcrumbs-img">
          <img src={bgImage} alt="Breadcrumbs bg" />
        </div>
        <div className="breadcrumbs-text white-color">
          <h1 className="page-title">Test Series</h1>
        </div>
      </div>

      <Container className="py-4">
        <Row>
          {paperList.length > 0 ? (
            paperList.map((test) => (
              <Col key={test.id} md={12} lg={12} className="mb-4">
                <div className="p-3 border rounded shadow-sm h-100 d-flex justify-content-between demo-test-card shadow flex-wrap">
                  <div >
                    <div className="d-flex gap-2 align-items-center mb-3">
                    <h5 className="text-capitalize ">{test.title}</h5>
                    {/* <span className="badge bg-warning text-dark">
                      Test Series
                    </span> */}
                    </div>
                    <div className="d-flex">
                    <p className="mb-1 ">
                    {test.package_name}
                    </p>
                    <p className="mb-1 moke-question ">
                      {test.total_questions}
                    </p>
                    <p className="mb-1 moke-question">
                    {test.duration_minutes} mins
                    </p>
                    <p
                      className={`mb-2 moke-question text-${
                        test.status === "active" ? "success" : "warning"
                      }`}
                    >
                      <strong> {test.status}</strong>
                    </p>
                    </div>
                  </div>
                  <div className="d-flex justify-content-center align-items-center">
                    <button
                      type="button"
                      className="educate-btn w-100"
                      disabled={test.status !== "active"}
                      onClick={() => handleAction(test)}
                    >
                      {test.test_status === "active"
                        ? "Show Result"
                        : test.status === "active"
                        ? "Test Series"
                        : "Upcoming"}
                      <span className="educate-btn__curve"></span>
                    </button>
                  </div>
                </div>
              </Col>
            ))
          ) : (
            <Col>
              <div className="text-center p-5 border rounded shadow-sm">
                <h5>No tests available</h5>
                <p>Please check back later.</p>
              </div>
            </Col>
          )}
        </Row>

        {/* Modal for Instructions */}
        {/* <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>Test Instructions</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedTest && (
              <>
                <p>
                  <strong>Test Name:</strong> {selectedTest.title}
                </p>
                <p>
                  <strong>Duration:</strong> {selectedTest.duration_minutes}{" "}
                  mins
                </p>
                <p>
                  <strong>Total Questions:</strong>{" "}
                  {selectedTest.total_questions}
                </p>
                <p>
                  <strong>Total marks:</strong> {selectedTest.total_marks}
                </p>
                <p>
                  <strong>Passing marks:</strong> {selectedTest.passing_marks}
                </p>
                <hr />
                <ul className="mb-0 mt-3 ps-3">
                  <li dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(selectedTest?.description || ""),
                      }}
                    />
                   {renderInstructions(selectedTest.description)} 
                </ul>
              </>
            )}
          </Modal.Body>
          <Modal.Footer className="align-items-stretch">
            <button
              className="educate-btn bg-danger"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </button>
            <button
              className="educate-btn"
              onClick={() => handleStartTest(selectedTest)}
            >
              Start Test
              <span className="educate-btn__curve"></span>
            </button>
          </Modal.Footer>
        </Modal> */}



      </Container>
    </section>
  );
};

export default SectionalTest;
